import ReactGA from 'react-ga4';
import { SELECTED_COMPANY_ID } from '../constants';

const sendEventTrack = (eventName: string, value?: any) => {
  ReactGA.event(eventName, {
    ...value,
    companyId: Number(localStorage.getItem(SELECTED_COMPANY_ID))
  });
};

export { sendEventTrack };
